<template>
    <b-form-group
        :label="label"
        :description="description"
        :invalid-feedback="invalidFeedback === null ? error : invalidFeedback"
        :state="state"
    >
        <b-form-checkbox v-model="localValue" v-bind="attrs" v-on="listeners" :state="state">
            <slot></slot>
        </b-form-checkbox>
    </b-form-group>
</template>

<script>
import { formFieldMixin } from '../../../mixins/form-field-mixin';

export default {
    name: 'FormCheckbox',
    mixins: [formFieldMixin],
    props: {
        value: {
            type: Boolean,
        },
        invalidFeedback: {
            type: String,
            default: null,
        },
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
    },
};
</script>